import { render, staticRenderFns } from "./MarkedTool.vue?vue&type=template&id=72b3478c&scoped=true&"
import script from "./MarkedTool.vue?vue&type=script&lang=js&"
export * from "./MarkedTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b3478c",
  null
  
)

export default component.exports